import React from 'react';
import { BellIcon, ChevronLeftIcon, UserCircleIcon } from 'lucide-react';
import { motion } from 'framer-motion';
interface TopBarProps {
  title?: string;
  showBack?: boolean;
  onBack?: () => void;
  onNotificationClick?: () => void;
  unreadCount?: number;
  transparent?: boolean;
}
export function TopBar({
  title,
  showBack,
  onBack,
  onNotificationClick,
  unreadCount = 3,
  transparent = false
}: TopBarProps) {
  return <div className={`px-4 py-4 flex items-center justify-between z-10 sticky top-0 ${transparent ? 'bg-transparent' : 'bg-slate-50/90 backdrop-blur-md border-b border-gray-100'}`} data-id="element-47">
      <div className="flex items-center gap-3" data-id="element-48">
        {showBack ? <button onClick={onBack} className="p-2 -ml-2 rounded-full hover:bg-gray-100 transition-colors" data-id="element-49">
            <ChevronLeftIcon className="w-6 h-6 text-[#1B3B36]" data-id="element-50" />
          </button> : <div className="w-10 h-10 rounded-full bg-[#1B3B36] flex items-center justify-center text-white font-bold shadow-sm" data-id="element-51">
            AO
          </div>}
        {title && <h1 className="text-lg font-bold text-[#1B3B36]" data-id="element-52">{title}</h1>}
      </div>

      <button onClick={onNotificationClick} className="p-2 -mr-2 rounded-full hover:bg-gray-100 transition-colors relative" data-id="element-53">
        <BellIcon className="w-6 h-6 text-[#1B3B36]" data-id="element-54" />
        {unreadCount > 0 && <motion.div initial={{
        scale: 0
      }} animate={{
        scale: 1
      }} className="absolute top-1.5 right-2 w-2.5 h-2.5 bg-amber-500 rounded-full border-2 border-slate-50" data-id="element-55" />}
      </button>
    </div>;
}